export const SERVICE_CODE = 'TRAINING_STUDENT_TYPES' + '_SERVICE';
